import { createSelector } from "reselect";
import { isEmpty, map } from "lodash";

const getData = state => {
  const images = state.profile.images;
  if (isEmpty(images)) {
    return [];
  }

  let updatedImages = map(images, image => ({
    src: image.image,
    thumbnail: image.thumbnail,
    thumbnailWidth: 320,
    thumbnailHeight: 212
  }));
  return updatedImages;
};

const getMemberGalleryImages = createSelector(getData, images => images);
export default getMemberGalleryImages;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberGalleryImages.js